export enum PlanningRouteStatusEnum {
  DRAFT = 'DRAFT',
  // OPTIMIZING = 'OPTIMIZING',
  DISPATCHED = 'DISPATCHED',
  PARTIAL_DISPATCHED = 'PARTIAL_DISPATCHED'
}
